// src/ui/Skeletons.jsx
import React from "react";

export const shimmer = "animate-pulse bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200";

export function ListSkeleton() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="border rounded-2xl overflow-hidden">
          <div className={`aspect-[16/10] ${shimmer}`} />
          <div className="p-5 space-y-3">
            <div className={`h-4 w-24 ${shimmer} rounded`} />
            <div className={`h-6 w-3/4 ${shimmer} rounded`} />
            <div className={`h-4 w-full ${shimmer} rounded`} />
            <div className={`h-4 w-5/6 ${shimmer} rounded`} />
          </div>
        </div>
      ))}
    </div>
  );
}

export function PostSkeleton() {
  return (
    <main className="mx-auto max-w-3xl px-4 py-10">
      <div className={`h-7 w-28 ${shimmer} rounded mb-3`} />
      <div className={`h-10 w-3/4 ${shimmer} rounded mb-4`} />
      <div className={`h-5 w-2/3 ${shimmer} rounded mb-6`} />
      <div className={`aspect-[16/9] ${shimmer} rounded-2xl mb-8`} />
      <div className={`h-4 w-full ${shimmer} rounded mb-3`} />
      <div className={`h-4 w-5/6 ${shimmer} rounded mb-3`} />
      <div className={`h-4 w-4/6 ${shimmer} rounded`} />
    </main>
  );
}
